import {array, boolean, number, object, string} from 'yup';
import {ConsumerInformation, Order} from '../../../redux/entities/inventory/order';
import {createAllObjectShapes} from '../../../util/yup';
import {makeConsumerInformation} from '../../../redux/factory/inventory/order';
import {isNullOrWhitespace} from '../../../util/string';
import {OrderItem, OrderItemOption} from '../../../redux/entities/inventory/joining/orderItem';
import {propertyOf} from "../../../util";

export const WithdrawalSchema = object<Order>({
  id: string().nullable(),
  orderItems: array(),
  consumerInformation: object().shape(createAllObjectShapes(makeConsumerInformation(), undefined, {
    emailAddress: string().required('Email is a required field.').email('Email must be in a valid format.'),
    signaturePath: string().nullable(),
    jobTitle: string().nullable(),
    comment: string().nullable(),
    everythingFound: boolean(),
    everythingFoundComment: string().nullable(),
    additionalComment: string().nullable()
  })),
  programId: string().required('Program is a required field.'),
  houseId: string().nullable(),
  isFromWarehouse: boolean().nullable()
});

export const getConsumerInfoName = (name: keyof ConsumerInformation) =>
  `${propertyOf<Order>('consumerInformation')}.${name}`;

export const getOrderName = propertyOf<Order>;

// Helper types and functions used by Formik-driven forms (eg. public Landing page)

// Minimal shape for selected items map used to construct Order.orderItems
export type SelectedItemForBuild = { quantity?: number; notes?: string; checked?: boolean };

// Builds an OrderItem[] compatible with validation rules from a map of selected items
export function buildOrderItemsFromSelection(selected: Record<string, SelectedItemForBuild>): OrderItem[] {
  return Object.entries(selected)
    .filter(([, v]) => !!v?.checked && (v.quantity ?? 0) > 0)
    .map(([itemId, v]) => ({
      id: '',
      orderId: '',
      itemId,
      storeQuantity: v.quantity ?? 0,
      warehouseQuantity: 0,
      extraComment: v.notes ?? '',
      itemOptions: []
    } as any));
}
